import api from '@src/api/clients';

const BASE_URL = 'v1/keys/';

export const listApiKeys = ({ clientId, parentCompanyId } = {}) => {
  const params = {};
  if (parentCompanyId) params.parent_company_id = parentCompanyId;
  else if (clientId) params.client_id = clientId;
  return api.request({ url: BASE_URL, method: 'GET', payload: params });
};

export const createApiKey = (payload) =>
  api.request({ url: BASE_URL, method: 'POST', payload });

// Only `label` and `spend_includes_fees` are editable.
export const updateApiKey = (keyId, payload) =>
  api.request({ url: `${BASE_URL}${keyId}/`, method: 'PATCH', payload });

export const revokeApiKey = (keyId) =>
  api.request({ url: `${BASE_URL}${keyId}/`, method: 'DELETE' });

export default { listApiKeys, createApiKey, updateApiKey, revokeApiKey };
